var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-modal-page"},[(_vm.loaded)?_c('CardModal'):_c('AppLoadingProgressBars')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }